import styled, { css } from 'styled-components';

import { Size } from 'src/types';
import { mixinThemingShape } from '../../theme';

type ButtonWrapperProps = {
  isInverted?: boolean;
  size?: Size;
};

export const ButtonWrapper = styled.button<ButtonWrapperProps>`
  width: auto;
  min-width: 10em;
  display: inline-block;
  text-align: center;
  border: none;
  text-decoration: none;
  text-transform: uppercase;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  background-color: transparent;
  transition: transform ease-in 0.1s;
  font-size: inherit;
  font-family: inherit;
  vertical-align: middle;

  &:hover {
    cursor: pointer;
  }

  &:focus {
    outline: none;
    box-shadow: inset 0 0 0 3px #7bb5fa; /* TODO: theme */
  }

  &:active {
    transform: scale(0.9);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7; /* TODO: theme */
    & > * {
      pointer-events: none;
    }
    transform: none;
  }

  /* Theming Overrides */
  ${mixinThemingShape('button', {
    padding: '0.625em 1.25em',
    borderRadius: '1.5em',
    fontWeight: 600,
  })}
  ${({ theme }) => theme?.overrides?.Button}

  ${({ size }) =>
    size === 'small' &&
    css`
      font-size: 0.75em;
      text-transform: none;
      font-weight: normal;
    `}
`;

export const PrimaryButton = styled(ButtonWrapper)`
  color: #fff; /* TODO: theme */
  background-color: #157efb; /* TODO: theme */

  &:hover,
  &:focus {
    background-color: #1174ea; /* TODO: theme */
  }

  &:active {
    background-color: #0d65cd; /* TODO: theme */
  }
  ${({ theme }) => theme?.overrides?.Button.PrimaryButton}
`;

export const SecondaryButton = styled(ButtonWrapper)`
  color: #157efb; /* TODO: theme */
  background-color: #fff; /* TODO: theme */

  &:hover,
  &:focus {
    color: #0d65cd; /* TODO: theme */
  }

  &:active {
    color: #0d65cd; /* TODO: theme */
    background-color: #ececf0; /* TODO: theme */
  }
  ${({ theme }) => theme?.overrides?.Button.SecondaryButton}
  ${({ isInverted }) =>
    isInverted &&
    css`
      &:hover,
      &:focus {
        background-color: #f5f5f8; /* TODO: theme */
      }
    `}
`;

export const TertiaryButton = styled(ButtonWrapper)`
  color: #157efb; /* TODO: theme */
  border: 1px solid #157efb; /* TODO: theme */

  &:active,
  &:hover,
  &:focus {
    color: #0d65cd; /* TODO: theme */
    border-color: #0d65cd; /* TODO: theme */
  }

  &:active {
    background-color: #f5f5f8; /* TODO: theme */
  }
  ${({ theme }) => theme?.overrides?.Button.TertiaryButton}

  ${({ isInverted }) =>
    isInverted &&
    css`
      color: #f5f5f8; /* TODO: theme */
      border-color: #f5f5f8; /* TODO: theme */

      &:hover,
      &:focus {
        color: #fff; /* TODO: theme */
        border-color: #fff; /* TODO: theme */
      }

      &:active {
        background-color: #000; /* TODO: theme */
      }
    `}
`;

export const TextButton = styled(ButtonWrapper)`
  color: #157efb; /* TODO: theme */
  border-radius: unset;

  &:active,
  &:hover,
  &:focus {
    color: #0d65cd; /* TODO: theme */
  }
  ${({ theme }) => theme?.overrides?.Button.TextButton}

  ${({ isInverted }) =>
    isInverted &&
    css`
      color: #f5f5f8; /* TODO: theme */

      &:active,
      &:hover,
      &:focus {
        color: #fff; /* TODO: theme */
      }
    `}

  ${({ size }) =>
    size === 'small' &&
    css`
      padding: 0;
      min-width: auto;
    `}
`;
